import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { firestored } from "../../firebase/firebaseConfig";
import { Mail, User, Phone, BadgeCheck, X } from "lucide-react";

export default function ProfilePage({ userId, onclose }) {
  console.log("userId", userId);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
    setLoading(false); // ✅ stop loader
    return;
  }// 👈 prevent crash

    const fetchUser = async () => {
      try {
        const ref = doc(firestored, "users", userId);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setUser(snap.data());
        } else {
          setUser(null);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
        <div className="animate-spin h-12 w-12 border-4 border-gray-300 border-t-indigo-600 rounded-full"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50 text-white">
        User not found
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      {/* Modal Card */}
      <div className="relative w-[90%] md:w-[70%] lg:w-[40%] rounded-3xl overflow-hidden shadow-2xl bg-white">
        {/* Close Button */}
        <button
          onClick={onclose}
          className="absolute top-4 right-4 bg-white/80 hover:bg-white p-2 rounded-full shadow z-10"
        >
          <X size={18} />
        </button>

        {/* Cover */}
        <div className="h-32 bg-[#1E293B] relative">
          <div className="absolute inset-0 bg-black/10"></div>
        </div>

        {/* Avatar */}
        <div className="absolute top-16 left-8">
          <img
            src={user.profilepicture || "/assets/user.png"}
            alt="profile"
            className="w-32 h-32 rounded-full border-4 border-white object-cover shadow-xl"
          />
        </div>

        {/* Content */}
        <div className="pt-20 px-8 pb-10">
          {/* Name Section */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-3xl font-bold text-gray-900">
                  {user.firstname} {user.lastname}
                </h1>
              </div>

              <p className="text-sm text-gray-400 mt-2">
                {user.role || "User"}
              </p>
            </div>
          </div>

          {/* Info Cards */}
          <div className="flex flex-col items-center gap-5 mt-10">
            <div className={`flex items-center w-full gap-3 p-5 rounded-2xl bg-gray-50 border hover:shadow-md transition`}>
              <Mail className="text-indigo-600" />
              <div>
                <p className="text-xs text-gray-500">Email</p>
                <p className="font-medium text-gray-800 break-all">
                  {user.email}
                </p>
              </div>
            </div>

            {user.phonenumber && (
              <div className="flex items-center w-full gap-3 p-5 rounded-2xl bg-gray-50 border hover:shadow-md transition">
                <Phone className="text-indigo-600" />
                <div>
                  <p className="text-xs text-gray-500">Phone</p>
                  <p className="font-medium text-gray-800">
                    {user.phonenumber}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
